import ClusterIconHover from './component'

export default ClusterIconHover
